// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"UnsupportedQuestionType_actionButton__pNP3o","title":"UnsupportedQuestionType_title__1MIKy"};